export const ListsHeaders = [
  { label: "Title", map: "name", options: { copy: true, sort: true, isLink: true } },
  { label: "Items", map: "itemCount", options: { sort: true } },
  { label: "Created on", map: "created_at", options: { sort: true } },
  { label: "Created by", map: "created_by", options: { sort: true } },
  // { label: "Edit", map: "edit", options: { sort: false } },
  { label: "Copy", map: "copy", options: { copy: true, sort: false, index: true } },
  { label: "Delete", map: "delete", options: { sort: false, index: true } },
];
export const ListsEditHeaders = [
  { label: "", map: "", options: { copy: true, sort: false } },
  { label: "Image", map: "image", options: { sort: false } },
  { label: "Title", map: "title", options: { sort: false } },
  { label: "Display Value", map: "display_value", options: { sort: false, infoMessage: "Display value will show on the runtime in any application. If its empty it shows the default title. " } },
  { label: "Math Value", map: "math_value", options: { sort: false, infoMessage: "Numeric field used for calculation in rules. If empty, text value will be used." } },
  { label: "Show/Hide", map: "visibility", options: { sort: false } },
  { label: "Help Text", map: "visibility", options: { sort: false } },
  { label: "", map: "", options: { copy: true, sort: false } },
];
export const CREATE: string = "Create";
export const LISTS: string = "Lists";
export const TAXONOMY: string = "Taxonomy";
export const GMS: string = "GMS";
export const SAVE: string = "Save"
export const EDIT: string = "Edit"
export const CANCEL: string = "Cancel"
export const LISTS_ROUTE: string = "/gms/taxonomy/lists"
export const ADD_NEW: string = "Add New"
export const SHOW_HIDE: string = "Show/Hide"
export const DISPLAY_VALUE: string = "Display Value"
export const TITLE: string = "Title"
export const IMAGE: string = "Image"
export const ITEMS: string = "Items"
export const LIST_NAME: string = "List Name"
export const BULK_ACTION: string = "Bulk Action";
export const LIST_CREATE: string = "listmodule_create";
export const LIST_READ: string = "listmodule_read";
export const LIST_UPDATE: string = "listmodule_update";
export const LIST_DELETE: string = "listmodule_delete";
